import React from "react";

import { calculateMaxEstimatedCost } from "ComparePlans/calculateCost";
import { calculatePlanDeviationProps } from "QuotePage/Selectors";
import formatCurrency from "Utils/formatCurrency";

import ColoredDot from "Common/ColoredDot";
import { finePrintLabels, splitHospitalFinePrintSections } from "Common/finePrintSections";

import { DetailHeader, DetailContent } from "./DetailRows";

import type { MedicalPlanPrice } from "Utils/types";

const renderCostCell = function (plan: MedicalPlanPrice, serviceType: string, planDeviationProps: any) {
  const devKey = /^drug_tier:/.test(serviceType) ? "brand_drugs" : serviceType;
  if (typeof plan.estimated_costs[serviceType] === "undefined") {
    return null;
  }

  return [
    <ColoredDot
      key="dot"
      value={plan.estimated_costs[serviceType]}
      mean={planDeviationProps[`mean_${devKey}`]}
      stdev={planDeviationProps[`stdev_${devKey}`]}
    />,

    <span key="value"> {formatCurrency(calculateMaxEstimatedCost(plan, serviceType))}</span>,
  ];
};

export default function EstimatedCosts({ plans, planDeviationProps }: Props) {
  const content = [];

  // This is necessary because this gets used in the employee side,
  // which will not have access to all plans, and thus needs to calculate
  // based on what it has.
  if (planDeviationProps === undefined || planDeviationProps === null) {
    planDeviationProps = calculatePlanDeviationProps(plans);
  }

  const dontShowSplit = {
    hospitalization_physician: true,
    surgery_staff: true,
    labor: true,
  };

  plans.forEach((plan) => {
    const planContent = {};
    finePrintLabels.forEach(([key, label]) => {
      planContent[label] = [];

      splitHospitalFinePrintSections[key].forEach((config) => {
        let usedLabel = config.label;
        if (usedLabel == "Drug Deductible") {
          return null;
        }

        if (dontShowSplit.hasOwnProperty(config.key)) {
          return null;
        }
        usedLabel = usedLabel.split(" - ")[0];

        planContent[label].push(DetailHeader(usedLabel));
        planContent[label].push(DetailContent(renderCostCell(plan, config.key, planDeviationProps)));
      });
    });
    content.push(planContent);
  });
  return content;
}

type Props = {
  plans: Array<MedicalPlanPrice>;
  planDeviationProps?: Record<string, any>;
};
